export default __webpack_public_path__ + "static/media/waveHeader.b575b402.png";